import { FC } from 'react';

import { FormModal } from './components/forms/modal-base';
import { TemplatesTable } from './components/table/templates-table';
import { popupTypeComponentMap } from './constants/popup-type-map.constant';
import { TemplatePopupStore } from './store/template-popup.store';

export const DocumentsTemplatesPage: FC = () => {
  const type = TemplatePopupStore(({ type }) => type);

  return (
    <div className="flex w-full flex-1 flex-col gap-4 lg:py-4 lg:pl-4">
      <FormModal />
      {popupTypeComponentMap[type]}
      <TemplatesTable />
    </div>
  );
};
